import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageview } from "@/lib/platform/analytics";

/** Sends a page view on every route change (Plausible runs in manual mode, see analytics.ts). */
export function PageViews() {
  const { pathname } = useLocation();
  useEffect(() => trackPageview(pathname), [pathname]);
  return null;
}
